import { Form } from 'react-bootstrap'

export interface TextFormControlProps {
  value: string | undefined
  maxLength?: number
  disabled?: boolean
  readOnly?: boolean
  changeHandler: (value: string) => void
  isValid?: () => boolean
  blurHandler?: () => void
  enterTapHandler?: () => void
  formatFunction?: (value: string) => string
}

export default (props: TextFormControlProps) => {

  const onChange = (value: string) => {
    if (props.formatFunction) { value = props.formatFunction(value) }
    props.changeHandler(value)
  }

  return (
    <Form.Control type="text"
      value={props.value || ''}
      onChange={e => onChange(e.target.value)}
      disabled={props.disabled}
      maxLength={props.maxLength}
      readOnly={props.readOnly}
      isInvalid={props.value !== undefined && (props.isValid !== undefined && !props.isValid())}
      onBlur={() => { onChange(props.value || ''); if (props.blurHandler) { props.blurHandler() } }}
      onKeyDown={(e: { keyCode: number }) => { if (props.enterTapHandler && e.keyCode === 13) { props.enterTapHandler() } }} />
  )
}
